import { React } from 'react'
import "./FilterOneSelect.css"
import { Checkbox, FormControlLabel, Typography } from '@mui/material';

const FilterOneSelect = ({ title,field_name, selectedItems, setSelectedItems, addNode, removeNode, path }) => {


    const checkboxStyles = {
        color: '#D2D2D2',
        '&.Mui-checked': { color: '#239DAB' },
        '&:hover': { color: '#239DAB', backgroundColor: 'rgba(35, 157, 171, 0.1)' },
    };

    const handleCheckboxChange = (field_name) => (event) => {
        const isChecked = event.target.checked;
        const fullPath = [...path, { key: field_name, value: 0 }];
        if (event.target.checked) {
            addNode(fullPath, { is_group: 0, value: event.target.checked });
        }
        else {
            removeNode(fullPath);
        }
        setSelectedItems((prev) => ({
            ...prev,
            [field_name]: isChecked,
        }));
    };


    return (
        <div className='border-top-single-check'>
            <FormControlLabel
                sx={{
                    marginTop: '-8px'
                }}
                label={<Typography sx={{ color: "#000", fontFamily: "Sfpro700", fontSize: "13px", letterSpacing: "0.352px" }}>
                    {field_name}
                </Typography>}
                control={
                    <Checkbox
                        checked={selectedItems[title] || false}
                        onClick={(event) => event.stopPropagation()}
                        onChange={handleCheckboxChange(title)}
                        sx={checkboxStyles}
                    />}
            />
        </div>
    );
}

export default FilterOneSelect
